export class IsbnModel {
    id?:number;
    dirtyNumber:string;
    cleanNumber:string;
}

export class IsbnNotValidatedPair {
    id?:number;
    dirtyChoices:any;
    cleanChoices:any;
}

export class IsbnPageAbleModel {
    totalItems: number;
    items: IsbnModel[]=[];
}

export class IsbnResult {
    errorCode: number;
    isbn: IsbnModel;
    succecss: boolean;
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/isbn.model.ts